import api from './api';

export async function fetchSubjectCategories(params = {}) {
  const response = await api.get('/exam-courses/subject-categories', {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function setDefaultSubjectCategory(payload) {
  const response = await api.post('/exam-courses/subject-categories/default', payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
